import React from 'react';
import { Button } from '@/components/ui/button';

import type { OpenCandidatesActionFn, ProgramControlCommonProps, SubmitReportFn } from '../controlTypes';

type DshProgramControlsProps = ProgramControlCommonProps & {
  onOpenCandidatesAction: OpenCandidatesActionFn;
  onSubmitReport: SubmitReportFn;
};

export const DshProgramControls = ({
  values,
  onFilterChange,
  actionRowClass,
  renderStandardActionButtons,
  renderReportActionLabel,
  onOpenCandidatesAction,
  onSubmitReport,
}: DshProgramControlsProps) => (
  <div className="mb-3 flex flex-wrap items-end justify-between gap-4 rounded-[var(--border-radius-medium)] border border-[var(--neutral-gray-40)] bg-white px-4 py-3">
    <div className="flex flex-wrap items-center gap-6">
      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Department</div>
        <div className="flex flex-wrap items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="dsh-department" value="all" checked={values.departmentFilter === 'all'} onChange={() => onFilterChange('departmentFilter', 'all')} />All</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="dsh-department" value="hub1" checked={values.departmentFilter === 'hub1'} onChange={() => onFilterChange('departmentFilter', 'hub1')} />Hub 1</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="dsh-department" value="hub2" checked={values.departmentFilter === 'hub2'} onChange={() => onFilterChange('departmentFilter', 'hub2')} />Hub 2</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="dsh-department" value="hub3" checked={values.departmentFilter === 'hub3'} onChange={() => onFilterChange('departmentFilter', 'hub3')} />Hub 3</label>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className="text-xs font-semibold uppercase tracking-wide text-[var(--neutral-gray-100)]">Cancelled</div>
        <div className="flex items-center gap-4 text-xs text-[var(--neutral-gray-120)]">
          <label className="flex items-center gap-1.5"><input type="radio" name="dsh-cancelled" value="y" checked={values.dshCancelledFilter === 'y'} onChange={() => onFilterChange('dshCancelledFilter', 'y')} />Yes</label>
          <label className="flex items-center gap-1.5"><input type="radio" name="dsh-cancelled" value="n" checked={values.dshCancelledFilter === 'n'} onChange={() => onFilterChange('dshCancelledFilter', 'n')} />No</label>
        </div>
      </div>
    </div>

    <div className={actionRowClass}>
      {renderStandardActionButtons()}
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onOpenCandidatesAction('court-list-report')}>
        {renderReportActionLabel('+ Court List Report')}
      </Button>
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={() => onSubmitReport({ action: 'all-report', download: '1' })}>
        {renderReportActionLabel('All')}
      </Button>
    </div>
  </div>
);
